import React from "react";
import styled from "styled-components";
import SimpleModal from "../../../SimpleModal";
import { ReactTable } from "../../ReactTable";
import Button from "../../UI/Button";
import { Removal790AColumns } from "./columns/Removal790AColumns";
import { getHeaderContent } from "./utils/getHeaderContent";

const ModalHeader = styled.h3`
  display: flex;
  flex-direction: column;
`;

const ModalBody = styled.div`
  padding: 10px 20px;
`;
const ModalFooter = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: end;
`;

export const DeleteLinkageModal = ({
  isOpen,
  setIsOpen,
  linkageDeletionObject: {
    linkageRowDeletionData,
    linkageDeletionId,
    linkagesSchemaProps: {
      linkages: { fromFieldArray, removalTableColumn, removeRow },
    },
  },
  deleteItemByIndex,
  closePopupMenu,
}) => {
  // Linkage removal columns, based off linkages schema prop "removalTableColumn", ie. "Removal790AColumns"
  const columnsResolver = (removalTableColumn) => {
    const lookup = {
      Removal790AColumns: Removal790AColumns({
        linkageDeletionId,
        removeRow,
      }),
    };
    return lookup[removalTableColumn] || [];
  };

  const columns = columnsResolver(removalTableColumn);

  const { header, content } = getHeaderContent({
    fromFieldArray,
    linkageDeletionId,
    linkageRowDeletionData,
  });

  return (
    <SimpleModal
      modalStatus={isOpen}
      toggleModal={() => setIsOpen(!isOpen)}
      onRequestClose={() => setIsOpen(false)}
      minWidth={"70%"}
      renderButton={() => null}
    >
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>
        {content}
        {columns?.length && (
          <ReactTable
            columns={columns}
            tableTheme="linkageDeletionTheme"
            data={linkageRowDeletionData}
            showRowNumbers={true}
            showPagination={
              !!linkageRowDeletionData
                ? linkageRowDeletionData.length > 5
                : false
            }
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => setIsOpen(false)}
          coloring="cancel"
          type="button"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            setIsOpen(false);
            deleteItemByIndex();
            closePopupMenu();
          }}
          coloring="red"
          type="button"
        >
          Delete
        </Button>
      </ModalFooter>
    </SimpleModal>
  );
};
